import { createAsyncSaga } from '@wahaaabello/redux-async-actions';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../../api';
import userActions from './actions';
import { Action } from 'redux-actions';

function* fetchUserActivities({ payload: { limit = 0 } = {} }) {
  try {
    const params: { limit?: number } = {};
    if (limit) {
      params.limit = limit;
    }
    const { activities } = yield call(api.fetchUserActivities, params);
    yield put(userActions.fetchUserActivitiesSuccess(activities));
    return activities;
  } catch (error) {
    yield put(userActions.fetchUserActivitiesFailure(error));
    throw error;
  }
}

function* fetchUserTodos() {
  try {
    const { usertodos } = yield call(api.fetchUserTodos);
    yield put(userActions.fetchUserTodosSuccess(usertodos));
    return usertodos;
  } catch (error) {
    yield put(userActions.fetchUserTodosFailure(error));
    throw error;
  }
}

function* fetchUserTransactions({ payload }: Action<any>) {
  try {
    const { transactions } = yield call(api.fetchUserTransactions, payload);
    yield put(
      userActions.fetchUserTransactionsSuccess({
        ...payload,
        transactions
      })
    );
    return transactions;
  } catch (error) {
    yield put(userActions.fetchUserTransactionsFailure(error));
    throw error;
  }
}

export default function* userSaga() {
  yield all([
    takeLatest(
      userActions.fetchUserActivitiesRequest.toString(),
      createAsyncSaga(fetchUserActivities)
    ),
    takeLatest(
      userActions.fetchUserTodosRequest.toString(),
      createAsyncSaga(fetchUserTodos)
    ),
    takeLatest(
      userActions.fetchUserTransactionsRequest.toString(),
      createAsyncSaga(fetchUserTransactions)
    )
  ]);
}
